import { useTimezone } from '@app/core/hooks/useTimezone';
import { getQueryParam } from '@mi-front/core';
import { ThumbnailsStream, ThumbnailsStreamV2 } from '@mi-front/ui';
import { PreviewBrush } from '../../components/preview/PreviewBrush';
import { PreviewFocusMarkers } from '../../components/preview/PreviewFocusMarkers';
import { PreviewWrapper } from '../../components/preview/elements';
import { STREAM_UI_CONFIG } from '../../consts';
import { useStreamSegmentsRange } from '../../hooks/segments/useStreamSegmentsQuery';
import { useLoggerRangeThumbnails } from './hooks/useLoggerRangeThumbnails';

export const LoggerVideoPreview = () => {
  const { thumbnails, isLoading } = useLoggerRangeThumbnails();
  const range = useStreamSegmentsRange();
  const tz = useTimezone();

  const streamProps = {
    compressed: true as const,
    tz,
    height: STREAM_UI_CONFIG.previewHeight,
    range,
    hideSeconds: true as const,
    disableHtmlEvents: true as const,
    renderSvg: () => <PreviewBrush />,
    renderHtml: () => <PreviewFocusMarkers />,
    thumbnails,
    thumbnailsLoading: isLoading,
  };

  return (
    <PreviewWrapper
      data-testid="logger-video-preview"
      data-range-from={range.from}
      data-range-to={range.to}
    >
      {getQueryParam('thumbs_v2') ? (
        <ThumbnailsStreamV2 {...streamProps} />
      ) : (
        <ThumbnailsStream {...streamProps} />
      )}
    </PreviewWrapper>
  );
};
